<template>
    <div class="teacher_modal_box">
        <b-modal ref="modal" :id="`teacher_modal_${modalId}`" hide-footer centered>
            <div class="teacher_content text-center" v-html="cv"></div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                type: Number,
                required: true,
            },
            cv: {
                type: String,
                required: true,
            },
        },
    }
</script>